"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default(theme) {
  return {
    root: {},
    textTitle: {
      fontFamily: 'Roboto',
      fontSize: '18px',
      fontWeight: 'normal',
      letterSpacing: '1.5px',
      color: theme.colors.text.black
    }
  };
};

exports.default = _default;